import store from '@/store';

export default class InternalCallEndEvent {
  constructor(body) {
    console.log('[COLLEAGUES] - Chamada finalizada', body);
    const params = {
      from: body.internalCall.from,
      to: body.internalCall.to,
      status: body.internalCall.status,
    };

    store.dispatch('colleagues/setInternalCallHangup', params);
    store.dispatch('channel/updateStatusVoice', 'available');
  }
}
